import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import {
  DialogContent,
  Grid,
  IconButton,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { TitleGeneralPopUp } from "./TitleGeneralPopUp";
import { DescriptionText } from "./DescriptionText";
import { ButtonSaveDocuments } from "./ButtonSaveDocuments";

const DialogCustom = withStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      borderRadius: " 15px",
      borderColor: theme.palette.secondary.main,
    },
  },
}))(Dialog);

const DialogContentCustom = withStyles((theme) => ({
  root: {
    "&.MuiDialogContent-root": {
      marginTop: "1rem",
      overflow: "hidden",
    },
  },
}))(DialogContent);

const styles = makeStyles((theme) => ({
  general: {
    margin: theme.spacing(4),
  },
  dos: {
    display: "flex",
    alignItems: "center",
  },
  close: {
    position: "absolute",
    right: "1vw",
    // top: "1vw",
  },
}));

/**
 * Alert for confirmation
 * @returns {React} React Component
 */
export const Confirmation = ({
  open = false,
  onClose,
  title = "Confirmation",
  msgError = "Are you sure what you are going to do?",
  onClick,
}) => {
  const classes = styles();
  return (
    <DialogCustom
      maxWidth={"md"}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      open={open}
    >
      <div className={classes.general}>
        <Grid container className={classes.dos}>
          <TitleGeneralPopUp children={title} variant={"h4"} />
          <div className={classes.close}>
            <IconButton>
              <CloseIcon color="secondary" onClick={onClose} />
            </IconButton>
          </div>
        </Grid>

        <DialogContentCustom>
          <DescriptionText children={msgError} variant={"h6"} />
        </DialogContentCustom>

        <Grid container style={{ marginTop: "0.5rem" }} spacing={4}>
          <Grid item xs={12} sm={6}>
            <ButtonSaveDocuments
              title="Cancelar"
              text={"Cancelar"}
              colorProperty="default"
              colorletter="black"
              onClick={onClose}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ButtonSaveDocuments
              title="Confirmar"
              text={"Confirmar"}
              colorProperty="secondary"
              colorletter="white"
              type="submit"
              onClick={onClick}
            />
          </Grid>
        </Grid>
      </div>
    </DialogCustom>
  );
};

Confirmation.propTypes = {
  /**
   * function to close alert
   */
  onClose: PropTypes.func.isRequired,
  /**
   * bool to know state of alert
   */
  open: PropTypes.bool.isRequired,
  /**
   * string with message
   */
  msgError: PropTypes.string,

  /**
   * string with title
   */
  title: PropTypes.string,
  /**
   * function to Confirmation button
   */
  onClick: PropTypes.func.isRequired,
};